import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { peritosService } from '../services/peritosService';

export default function PeritosList() {
  const navigate = useNavigate();
  const [datos, setDatos]       = useState({ content: [], totalElements: 0 });
  const [cargando, setCargando] = useState(false);
  const [q, setQ]               = useState('');
  const [pagina, setPagina]     = useState(0);
  const [error, setError]       = useState(null);

  const cargar = useCallback(async () => {
    setCargando(true);
    setError(null);
    try {
      const r = await peritosService.listar(q, pagina);
      setDatos(r.data);
    } catch {
      setError('Error al cargar peritos');
    } finally {
      setCargando(false);
    }
  }, [q, pagina]);

  useEffect(() => { cargar(); }, [cargar]);

  const buscar = (e) => {
    e.preventDefault();
    setPagina(0);
  };

  return (
    <div className="min-h-screen bg-gray-50">

      <div className="max-w-4xl mx-auto px-4 py-4 space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold text-gray-800">Peritos
            <span className="ml-2 text-sm font-normal text-gray-400">{datos.totalElements} peritos</span>
          </h2>
          <button
            onClick={() => navigate('/peritos/nuevo')}
            className="bg-primary-600 text-white font-semibold px-4 py-2 rounded-lg text-sm hover:bg-primary-700 transition"
          >
            + Nuevo
          </button>
        </div>

        {/* Buscador */}
        <form onSubmit={buscar} className="bg-white rounded-xl shadow-sm p-4 flex gap-2">
          <input
            type="text"
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder="Buscar por nombre o apellidos..."
            className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
          <button
            type="submit"
            className="bg-primary-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-primary-700 transition"
          >
            🔍
          </button>
          {q && (
            <button
              type="button"
              onClick={() => { setQ(''); setPagina(0); }}
              className="px-3 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50"
            >
              ✕
            </button>
          )}
        </form>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">{error}</div>
        )}

        {/* Lista */}
        {cargando ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
          </div>
        ) : (
          <div className="space-y-2">
            {datos.content.length === 0 ? (
              <div className="bg-white rounded-xl shadow-sm p-8 text-center text-gray-400">
                No se encontraron peritos
              </div>
            ) : (
              datos.content.map(p => (
                <div
                  key={p.id}
                  onClick={() => navigate(`/peritos/${p.id}`)}
                  className="bg-white rounded-xl shadow-sm p-4 cursor-pointer hover:shadow-md border border-transparent hover:border-primary-200 transition active:scale-95"
                >
                  <div className="flex items-start justify-between gap-2">
                    <div className="flex-1">
                      <p className="font-semibold text-gray-900 text-sm">
                        {p.nombre} {p.apellidos}
                      </p>
                      {p.localidad && (
                        <p className="text-xs text-gray-500 mt-0.5">{p.localidad}</p>
                      )}
                    </div>
                  </div>
                  <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500">
                    {p.movil && (
                      <a href={`tel:${p.movil}`} onClick={e => e.stopPropagation()}
                        className="text-primary-600 hover:underline">
                        📱 {p.movil}
                      </a>
                    )}
                    {p.telefono && (
                      <a href={`tel:${p.telefono}`} onClick={e => e.stopPropagation()}
                        className="text-primary-600 hover:underline">
                        📞 {p.telefono}
                      </a>
                    )}
                    {p.email && (
                      <a href={`mailto:${p.email}`} onClick={e => e.stopPropagation()}
                        className="text-primary-600 hover:underline">
                        ✉️ {p.email}
                      </a>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* Paginación */}
        {datos.totalPages > 1 && (
          <div className="flex items-center justify-center gap-2 py-4">
            <button
              onClick={() => setPagina(p => Math.max(0, p - 1))}
              disabled={pagina === 0}
              className="px-4 py-2 rounded-lg border border-gray-300 text-sm disabled:opacity-40 hover:bg-gray-50"
            >
              ← Anterior
            </button>
            <span className="text-sm text-gray-600">{pagina + 1} / {datos.totalPages}</span>
            <button
              onClick={() => setPagina(p => Math.min(datos.totalPages - 1, p + 1))}
              disabled={pagina >= datos.totalPages - 1}
              className="px-4 py-2 rounded-lg border border-gray-300 text-sm disabled:opacity-40 hover:bg-gray-50"
            >
              Siguiente →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
